module.exports = __webpack_public_path__ + "public/Icons/configSettingsIcon.svg?4e878f3e";